import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SEOPageTitle from 'components/shared/SEOPageTitle';
import PillTabs from 'components/shared/tabs/PillTabs';
import NutritionPrograms from 'components/nutrition/NutritionPrograms';
import NutritionRecipeBooks from 'components/nutrition/NutritionRecipeBooks';
import NutritionDirectory from 'components/nutrition/NutritionDirectory';
import AppBarContext from 'context/AppBarContext';

/**
 * Panel admin de "Mi Programa": tabs Programas | Recetarios (patrón ClientPaymentList).
 * Las asignaciones se hacen desde cada ítem (botón Asignar).
 */
function NutritionAdminPage() {
  const { t } = useTranslation(['nutrition', 'routes']);
  const { setAppBarButton, setAppBarTitle } = useContext(AppBarContext);
  const [tab, setTab] = useState(0);
  const pageTitle = t('nutrition', { ns: 'routes', defaultValue: 'Nutrición' });

  useEffect(() => {
    setAppBarButton(null);
    setAppBarTitle(pageTitle);
  }, [pageTitle, setAppBarButton, setAppBarTitle]);

  return (
    <>
      <SEOPageTitle title={pageTitle} />
      <PillTabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        ariaLabel={pageTitle}
        sx={{ mb: 2.5 }}
        tabs={[
          { key: 'programs', label: t('programsTab', { ns: 'nutrition', defaultValue: 'Programas' }) },
          { key: 'recipeBooks', label: t('recipeBooksTab', { ns: 'nutrition', defaultValue: 'Recetarios' }) },
          { key: 'intakes', label: t('intakesTab', { ns: 'nutrition', defaultValue: 'Datos de clientes' }) }
        ]}
      />
      {tab === 0 && <NutritionPrograms />}
      {tab === 1 && <NutritionRecipeBooks />}
      {tab === 2 && <NutritionDirectory />}
    </>
  );
}

export default NutritionAdminPage;
